import martinKucera2025cropped from "@assets/images/members/kucera-martin-2025-cropped.jpg?w=250&webp&imagetools";
import romanSvejda from "@assets/images/members/roman-svejda-cropped.jpg?w=250&webp&imagetools";
import type { MediaSrc } from "@components/common/MediaSrc.js";
import type { TeamMember } from "@core/schema/TeamMember.js";
import { TeamMemberType } from "@core/schema/TeamMemberType.js";
import type { Tenant } from "@core/schema/Tenant.js";

type Contact = Pick<TeamMember, "name" | "position" | "phone" | "email" | "linkedin" | "highlighted" | "type"> & {
	image?: MediaSrc;
};

export enum BookMeetingPerson {
	Kucera = "Kucera",
	Svejda = "Svejda",
}

export function getBookMeetingPeople(tenant: Tenant): Record<BookMeetingPerson, Contact> {
	return {
		[BookMeetingPerson.Kucera]: {
			name: "Martin Kučera",
			position: "CEO",
			phone: "+420 773 050 550",
			email: "kucera@fastest.cz",
			linkedin: "https://www.linkedin.com/in/kucera-martin",
			image: { src: martinKucera2025cropped, type: "image/webp" },
			highlighted: false,
			type: TeamMemberType.Internal,
		},
		[BookMeetingPerson.Svejda]: {
			name: "Roman Švejda",
			position: "Delivery Manager",
			phone: "+420 773 108 020",
			email: "roman.svejda@fastest.cz",
			image: { src: romanSvejda, type: "image/webp" },
			linkedin: "https://www.linkedin.com/in/roman-svejda",
			highlighted: false,
			type: TeamMemberType.Internal,
		},
	};
}
